// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"216":"0fcb1674","248":"f461652e","597":"701bd19f","962":"4d2fbad9"}[chunkId] + ".chunk.css";
};